import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import CommManager from "../../core/src/controllers/CommManager";
import BetModel from "../../core/src/model/BetModel";
import ErrorModel from "../../core/src/model/ErrorModel";
import SpinModel from "../../core/src/model/SpinModel";
import RequestRegister from "../../core/src/server/requests/RequestRegister";
import { State } from "../../core/src/states/State";
import { DefaultLayers } from "../../core/src/utils/Layers";
import ViewManager from "../../core/src/utils/ViewManager";
import ReelGroup from "../../core/src/views/ReelGroup";
import VendorModel from "../model/VendorModel";

export default class VendorFinishState extends State {

    protected _canExit: boolean = false;

    enter(){
        super.enter();
        this._canExit = false;
        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();

        // We must show the final syms, only when no winlines/ways will be shown,
        // because this state will be called right after the lines summary.
        if (!SpinModel.hasWinnings()) {
            const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
            let reels = Array.from(Array(reelGroup.reels.length).keys());
            let result = SpinModel.getFinalSymsForReels(reels);
            reelGroup.showFinalSymbols(result);
        }

        // Checking whether a closePlay or a settlePlay is needed
        if (VendorModel.lastPlayState == 4) {
            // The server expects closePlay
            CommManager.send(
                RequestRegister.get("closePlay"),
                this.requestComplete,
                this
            );
        } else {
            // The server expects settlePlay
            CommManager.send(
                RequestRegister.get("settlePlay"),
                this.settleComplete,
                this
            );
        } 
    }

    public canExit(): boolean {
        // Ensuring that all requests are done, then we allow to exit this state,
        // otherwise the skip chain will scramble the requests order, which leads to error 47
        // ERR_INVALID_SEQUENCE (47)
        return this._canExit; 
      }

    settleComplete(data) {
        VendorModel.update(data);
        BetModel.update(data)
        CommManager.send(
            RequestRegister.get("closePlay"),
            this.requestComplete,
            this
        );
    }

    requestComplete(data) {
        this._canExit = true;
        VendorModel.update(data);
        ErrorModel.update(data);
        BetModel.update(data);

        CommandManager.execute(Commands.UPDATE_UI);
        SpinModel.roundFinish = true;
        SpinModel.spinFinished = true;
        this.exit();
    }

}